/*
 * cr-glo-swatch-limit.js
 * Productpagina, mobiel: toon max 3 Globo-swatches naast elkaar en daarna een
 * "+N" pill die de rest onthult. Fail-safe: vindt het script de swatch-lijst
 * niet, dan doet het niets (swatches blijven zoals ze nu zijn).
 */
(function () {
  var MOBILE_MAX = 749; // px
  var LIMIT = 3;
  var observing = false;
  var obs = null;
  var rafPending = false;

  function isMobile() {
    return window.matchMedia('(max-width: ' + MOBILE_MAX + 'px)').matches;
  }

  // Direct element-children van de swatch-lijst binnen een detail-container.
  function getItems(container) {
    var list = container.querySelector('.globo--list') || container;
    var kids = [];
    for (var i = 0; i < list.children.length; i++) {
      var el = list.children[i];
      if (el.nodeType === 1 && !el.classList.contains('cr-swatch-more')) {
        kids.push(el);
      }
    }
    return kids;
  }

  function reset(container) {
    var hidden = container.querySelectorAll('.globo-swatch-hidden');
    for (var i = 0; i < hidden.length; i++) {
      hidden[i].classList.remove('globo-swatch-hidden');
    }
    var pill = container.querySelector('.cr-swatch-more');
    if (pill) pill.remove();
  }

  function applyOne(container) {
    reset(container);
    if (!isMobile()) return;

    var items = getItems(container);
    if (items.length <= LIMIT) return; // fail-safe: niks te limiteren

    for (var i = LIMIT; i < items.length; i++) {
      items[i].classList.add('globo-swatch-hidden');
    }

    var more = items.length - LIMIT;
    var pill = document.createElement('button');
    pill.type = 'button';
    pill.className = 'cr-swatch-more';
    pill.textContent = '+' + more;
    pill.setAttribute('aria-label', more + ' meer kleuren tonen');
    pill.addEventListener('click', function () {
      var hidden = container.querySelectorAll('.globo-swatch-hidden');
      for (var j = 0; j < hidden.length; j++) {
        hidden[j].classList.remove('globo-swatch-hidden');
      }
      pill.remove();
    });

    // Zet de pill direct na de 3e swatch, in dezelfde rij.
    items[LIMIT - 1].insertAdjacentElement('afterend', pill);
  }

  function run() {
    if (obs) obs.disconnect();
    var containers = document.querySelectorAll('.globo-product-groups-detail');
    for (var i = 0; i < containers.length; i++) {
      applyOne(containers[i]);
    }
    if (obs && observing) {
      obs.observe(document.body, { childList: true, subtree: true });
    }
  }

  function scheduleRun() {
    if (rafPending) return;
    rafPending = true;
    window.requestAnimationFrame(function () {
      rafPending = false;
      run();
    });
  }

  function init() {
    obs = new MutationObserver(function () { scheduleRun(); });
    observing = true;
    run();
    obs.observe(document.body, { childList: true, subtree: true });

    var rt;
    window.addEventListener('resize', function () {
      clearTimeout(rt);
      rt = setTimeout(run, 150);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
